import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";
import Account from "../../../classes/Account";

export default {
  routes: [
    {
      name: "accounts",
      path: "accounts/:filter?",
      meta: {
        auth: () => Account.canBeViewedBy(store.state.main.user),
        icon: "account",
        title: i18n.global.tc("Account", 100),
        crumbs: ["accounting"],
        color: "primary",
      },
      component: () => import("pages/admin/Accounts"),
    },
  ],

  dialogs: [
    {
      name: "account-new",
      path: "/admin/accounts/new/:type",
      meta: {
        auth: () => Account.canBeCreatedBy(store.state.main.user),
        color: "primary",
      },
      component: () => import("../../../dialogs/admin/AccountEdit"),
    },
    {
      name: "account-edit",
      path: "/admin/accounts/:accountID/edit",
      meta: {
        auth: () => Account.canBeCreatedBy(store.state.main.user),
        color: "primary",
      },
      component: () => import("../../../dialogs/admin/AccountEdit"),
    },
    {
      name: "account-view",
      path: "/admin/accounts/:accountID/view",
      meta: {
        auth: () => Account.canBeViewedBy(store.state.main.user),
        color: "primary",
      },
      component: () => import("../../../dialogs/admin/AccountView"),
    },
  ],
};
